import {
  IConfig,
  ConfigActionTypes,
  ADD_CONFIG,
  ADD_CONFIG_SLUG,
  GET_MENU_CATEGORIES_SUCCESS,
  GET_EXTRA_ACTIVITIES_SUCCESS,
} from './types'
import { initialState } from './initialState'

export const configReducer = (state = initialState, action: ConfigActionTypes): IConfig => {
  switch (action.type) {
    case ADD_CONFIG:
      return { ...state, ...action.payload }
    case ADD_CONFIG_SLUG:
      return { ...state, data: { ...state.data, [action.payload.name]: action.payload.section } }
    case GET_EXTRA_ACTIVITIES_SUCCESS:
      return { ...state, data: { ...state.data, [action.payload.name]: action.payload.activity } }
    case GET_MENU_CATEGORIES_SUCCESS:
      return { ...state, data: { ...state.data, [action.payload.name]: action.payload.menu } }
    default:
      return state
  }
}
